import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { useDispatch } from 'react-redux';
import cx from 'classnames';
import { hideModal } from 'cards/actions/modalActions';
import EnvelopeStamp from 'assets/images/invitations/envelope-stamp.svg';

import { CARD_TYPES } from '../../../../constants/CardTypes';
import styles from './ProofModal.module.less';

const ModalBodyText = {
  [CARD_TYPES.place]:
    "Customize your card, then we'll ship it to you for your review. When you're ready to place a full order, you’ll be able to assign guest names and tables. For now, we'll just focus on the design.",
  generic:
    "Customize your card, then we'll ship it to you for your review. When you're ready to place a full order, we'll go over guest addressing. For now, we'll just focus on the cards.",
};

interface ProofInfoModalProps {
  cardType?: string;
}

const ProofInfoModal: React.FC<ProofInfoModalProps> = ({ cardType = 'generic' }) => {
  const dispatch = useDispatch();
  return (
    <div className={styles.container}>
      <div className="modal-header">
        <img src={EnvelopeStamp} alt="Customizing a proof" className={styles.svg} />
        <h2 className={cx('modal-title', styles.title)}>Let’s create your proof!</h2>
      </div>
      <div className="modal-body">
        <p className={cx('text-left', styles.text)}>
          {ModalBodyText[cardType] || ModalBodyText.generic}
        </p>
      </div>
      <div className="modal-footer">
        <div className="text-group row">
          <ButtonV2 onClick={() => dispatch(hideModal())}>Got it!</ButtonV2>
        </div>
      </div>
    </div>
  );
};

export default ProofInfoModal;
